(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asp-christmas-gift-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.campaignReady)return;
    root.dataset.campaignReady='true';
    const slides=Array.from(root.querySelectorAll('[data-campaign-slide]'));
    const tabs=Array.from(root.querySelectorAll('[data-campaign-tab]'));
    const pause=root.querySelector('[data-campaign-pause]');
    const status=root.querySelector('[data-campaign-status]');
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let current=0,timer=null,paused=false;
    const delay=Number(root.dataset.delay)||8000;
    const stop=()=>{clearTimeout(timer);timer=null;};
    function schedule(){
      stop();
      if(root.dataset.autoplay!=='true'||paused||motion.matches||document.hidden||root.matches(':hover')||root.contains(document.activeElement))return;
      timer=setTimeout(()=>show(current+1,false),delay);
    }
    function show(index,announce){
      current=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{
        const active=i===current;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',String(!active));
        slide.inert=!active;
      });
      tabs.forEach((tab,i)=>tab.setAttribute('aria-current',String(i===current)));
      if(announce)status.textContent=tabs[current].textContent;
      schedule();
    }
    tabs.forEach((tab,i)=>tab.addEventListener('click',()=>show(i,true)));
    root.querySelector('[data-campaign-prev]').addEventListener('click',()=>show(current-1,true));
    root.querySelector('[data-campaign-next]').addEventListener('click',()=>show(current+1,true));
    pause.addEventListener('click',()=>{
      paused=!paused;
      pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);
      pause.querySelector('span').textContent=paused?'▶':'Ⅱ';
      schedule();
    });
    const carousel=root.querySelector('.asp-campaign');
    carousel.addEventListener('keydown',event=>{
      if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
        if(event.target.closest('input,select,textarea'))return;
        event.preventDefault();show(current+(event.key==='ArrowRight'?1:-1),true);
      }
    });
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',schedule);
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',event=>{if(!root.contains(event.relatedTarget))schedule();});
    document.addEventListener('visibilitychange',()=>document.hidden?stop():schedule());
    motion.addEventListener('change',schedule);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))stop();});
    show(0,false);
  }
  document.querySelectorAll('[data-campaign-carousel]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-campaign-carousel]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asp-christmas-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
 if(root.dataset.giftReady)return;root.dataset.giftReady='true';
 const grid=root.querySelector('[data-gift-products]');if(!grid)return;
 const cards=Array.from(grid.querySelectorAll('[data-gift-product]'));
 const budgetButtons=Array.from(root.querySelectorAll('[data-budget]'));
 const categoryButtons=Array.from(root.querySelectorAll('[data-category]'));
 const ranges={under15:[0,1500],'15to30':[1500,3000],'30to60':[3000,6000],'60to100':[6000,10000],over100:[10000,Infinity]};
 const params=new URLSearchParams(location.search);
 let budget=ranges[params.get('budget')]?params.get('budget'):'';
 let category=categoryButtons.some(b=>b.dataset.category===params.get('category'))?params.get('category'):'';
 function apply(updateUrl){
  const range=ranges[budget]||[0,Infinity];let count=0;
  cards.forEach(card=>{const price=Number(card.dataset.price);const matches=price>=range[0]&&price<range[1]&&(!category||card.dataset.categories.split(' ').includes(category));card.hidden=!matches;if(matches)count++;});
  budgetButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.budget===budget)));
  categoryButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category===category)));
  root.querySelector('[data-gift-count]').textContent=String(count);
  root.querySelector('[data-gift-empty]').hidden=count!==0;
  const labels=[];if(budget)labels.push(budgetButtons.find(b=>b.dataset.budget===budget).textContent.trim());if(category)labels.push(categoryButtons.find(b=>b.dataset.category===category).querySelector('strong').textContent.trim());
  root.querySelector('[data-gift-selection]').textContent=labels.join(' · ');
  if(updateUrl){const url=new URL(location.href);budget?url.searchParams.set('budget',budget):url.searchParams.delete('budget');category?url.searchParams.set('category',category):url.searchParams.delete('category');history.replaceState(null,'',url);}
 }
 function revealEdit(){root.querySelector('#gift-edit').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
 budgetButtons.forEach(b=>b.addEventListener('click',()=>{budget=b.dataset.budget;apply(true);revealEdit();}));
 categoryButtons.forEach(b=>b.addEventListener('click',()=>{category=category===b.dataset.category?'':b.dataset.category;apply(true);revealEdit();}));
 root.querySelectorAll('[data-gift-reset]').forEach(b=>b.addEventListener('click',()=>{budget='';category='';apply(true);}));
 root.querySelector('[data-gift-sort]').addEventListener('change',event=>{const mode=event.target.value;const ordered=[...cards].sort((a,b)=>mode==='price-up'?Number(a.dataset.price)-Number(b.dataset.price):mode==='price-down'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.order)-Number(b.dataset.order));ordered.forEach(card=>grid.appendChild(card));});
 apply(false);
}
document.querySelectorAll('[data-gift-guide]').forEach(init);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-gift-guide]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asp-christmas-signup"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.getElementById('asp-welcome');if(!root)return;const dialog=root.querySelector('dialog'),tab=root.querySelector('.asp-welcome-tab');let focusBefore;const key='asp-welcome-dismissed-until';function open(){if(dialog.open)return;focusBefore=document.activeElement;dialog.showModal();}function close(){dialog.close();try{sessionStorage.setItem(key,String(Date.now()+7*86400000));}catch(e){}if(focusBefore&&focusBefore.isConnected)focusBefore.focus();}tab.addEventListener('click',open);root.querySelectorAll('.asp-welcome-close,.asp-welcome-dismiss').forEach(b=>b.addEventListener('click',close));dialog.addEventListener('cancel',e=>{e.preventDefault();close();});dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)close();}});if(root.querySelector('[data-signup-success]')){tab.hidden=true;open();return;}if(root.querySelector('[data-signup-error]')){open();return;}let dismissed=false;try{dismissed=Number(sessionStorage.getItem(key))>Date.now();}catch(e){}if(!dismissed&&!/\/(cart|checkout|account|challenge)/.test(location.pathname)){setTimeout(()=>{if(!document.querySelector('dialog[open],.modal[open]'))open();},Number(root.dataset.delay));}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
